<template>
  <div>
    <loading-spinner />
    <div v-if="reports && reports.length > 0">
      <div
        v-if="reports && reports.length > 1"
        class="row"
      >
        <div class="col-md-3">
          <div class="form-group">
            <select
              id="report-select"
              v-model="reportIndex"
              class="form-control"
              @change="getReport()"
            >
              <option
                v-for="(r, index) in reports"
                :key="index"
                :value="index"
              >
                {{ r.sendDate | dateFormat }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-6">
          <info-card
            :title="report.openCount | numFormat"
            description="Opens"
            icon="envelope-open-text"
            icon-color="gray"
          />
        </div>
        <div class="col-lg-3 col-md-6">
          <info-card
            :title="report.clickCount | numFormat"
            description="Clicks"
            icon="mouse-pointer"
            icon-color="gray"
          />
        </div>
        <div class="col-lg-3 col-md-6">
          <info-card
            :title="report.bounceCount | numFormat"
            description="Bounced"
            icon="repeat"
            icon-color="gray"
          />
        </div>
        <div class="col-lg-3 col-md-6">
          <info-card
            :title="report.removeCount"
            description="Unsubscribes"
            icon="user-times"
            icon-color="gray"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <table class="table-list table-list-lines">
            <tr>
              <td class="table-list--title">
                Sent
              </td>
              <td>{{ report.sendCount | numFormat }}</td>
            </tr>
            <tr>
              <td class="table-list--title">
                Delivered
              </td>
              <td>{{ report.deliverCount | numFormat }} ({{ report.deliverPercent }}%)</td>
            </tr>
            <tr>
              <td class="table-list--title">
                Opens
              </td>
              <td>{{ report.openCount | numFormat }} ({{ report.openPercent }}%)</td>
            </tr>
            <tr>
              <td class="table-list--title">
                Clicks
              </td>
              <td>{{ report.clickCount | numFormat }} ({{ report.clickPercent }}%)</td>
            </tr>
            <tr>
              <td class="table-list--title">
                Net Clicks
              </td>
              <td>{{ report.netClickCount | numFormat }} ({{ report.netClickPercent }}%)</td>
            </tr>
          </table>
        </div>
        <div class="col-sm-6">
          <table class="table-list table-list-lines">
            <tr>
              <td class="table-list--title">
                Bounced
              </td>
              <td>{{ report.bounceCount | numFormat }} ({{ report.bouncePercent }}%)</td>
            </tr>
            <tr>
              <td class="table-list--title">
                Unique Opens
              </td>
              <td>{{ report.uniqueOpens | numFormat }} ({{ report.uniqueOpenPercent }}%)</td>
            </tr>
            <tr>
              <td class="table-list--title">
                Unsubscribes
              </td>
              <td>{{ report.removeCount | numFormat }} ({{ report.removePercent }}%)</td>
            </tr>
            <tr>
              <td class="table-list--title">
                Abuse Reports
              </td>
              <td>{{ report.abuseComplaint | numFormat }} ({{ report.abuseComplaintPercent }}%)</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <empty-state
      v-if="!reports || reports.length === 0"
      icon="browser"
      description="There are no reports associated with this campaign yet."
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import InfoCard from '../components/InfoCard'
import LoadingSpinner from '../components/LoadingSpinner'
import EmptyState from '../components/EmptyState'

export default {
  name: 'CampaignDetailsReport',
  components: {
    InfoCard,
    LoadingSpinner,
    EmptyState
  },
  data () {
    return {
      report: Object,
      reportIndex: 0
    }
  },
  computed: {
    ...mapGetters({
      reports: 'getCampaignReport',
      loadingStatus: 'getLoadingStatus'
    })
  },
  watch: {
    reports (val) {
      if (val) {
        this.report = this.reports[0]
      }
    }
  },
  mounted () {
    if (this.$route.query.campaignId) {
      this.$store.dispatch('setCampaignReport', { projectId: this.$route.query.campaignId })
    }
  },
  methods: {
    getReport () {
      this.report = this.reports[this.reportIndex]
    }
  }
}
</script>

<style lang="scss" scoped>
.report-empty-state {
  text-align: center;
  padding: 20px 0;
  svg {
    color: $secondary-light;
  }
}
.table-list {
    margin: 3rem 0;
    width: 100%;

    &.table-list-lines {
        tr {
            border-bottom: 1px solid #999;
            &:last-child {
                border: none;
            }
        }

    }
    tr {
        line-height: 5.5rem;

        td:last-child {
            text-align: right;
        }
    }

    .table-list--title {
        color: #000;
        font-weight: 600;
    }
}
</style>
